import React from 'react';

interface Props {
  completed: boolean;
  children?: React.ReactNode;
}

const QuestionStatus: React.FC<Props> = ({ completed, children }) => {
  const completedClass = completed ? 'completed' : '';
  return (
    <div className={`question-id-circle ${completedClass}`}>
      <span>{children}</span>
    </div>
  );
};

export default QuestionStatus;
